import Service from '@ember/service';
import { inject as service } from '@ember/service';
import pluralize from 'cio/utils/pluralize';
import DS from 'ember-data';
import AlertsService from './alerts';
import ApiService from './api';

export default class SegmentActionsService extends Service {
  @service api!: ApiService;
  @service alerts!: AlertsService;
  @service store!: DS.Store;

  archive(ids: string[]) {
    return this._action(ids, 'archive');
  }

  unarchive(ids: string[]) {
    return this._action(ids, 'unarchive');
  }

  delete(ids: string[]) {
    return this._action(ids, 'delete');
  }

  async _action(ids: string[], action: 'archive' | 'unarchive' | 'delete') {
    await this.api.post(`segments/${action}`, {
      data: {
        segment_ids: ids.map((id) => parseInt(id)),
      },
    });

    this.alerts.success(action, `${ids.length} ${pluralize(ids.length, 'segment')} ${action}d`);

    if (action === 'delete') {
      ids.forEach((id) => this.store.peekRecord('segment', id)?.unloadRecord());
    }
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your services.
declare module '@ember/service' {
  interface Registry {
    'segment-actions': SegmentActionsService;
  }
}
